import React from 'react';
import { Button, Stack } from '@mui/material';
import { useScreenShare } from '../../shared/contexts/ScreenShareProvider';

export interface IPreviewActionsProps {
	onBack: () => void;
}

// The two buttons under the preview tiles and on the PiP strip: back to the call page, share/stop.
export const PreviewActions = ({ onBack }: IPreviewActionsProps) => {
	const { isSharingScreen, startScreenShare, stopScreenShare } = useScreenShare();

	return (
		<Stack
			direction={'row'}
			gap={.5}
			// the preview container opens the call on click; the buttons must not bubble into it
			onClick={(e) => e.stopPropagation()}
		>
			<Button
				size={'small'}
				variant={'contained'}
				color={'primary'}
				disableElevation
				onClick={onBack}
				sx={{ flex: 1, whiteSpace: 'nowrap' }}
			>
				Back to call
			</Button>
			<Button
				size={'small'}
				variant={'contained'}
				color={isSharingScreen ? 'success' : 'inherit'}
				disableElevation
				onClick={() => isSharingScreen ? stopScreenShare() : startScreenShare()}
				sx={{ flex: 1, whiteSpace: 'nowrap' }}
			>
				{isSharingScreen ? 'Stop sharing' : 'Share screen'}
			</Button>
		</Stack>
	);
};
